import React from "react";
import "./AddUserModal.styles.scss";

// Component Imports
import { DefaultTextInput } from "../../../Inputs";

// MUI Imports
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

// Type Imports
import { IAddUser } from "../../../../pages/RoleManagement/RoleManagement.types";

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  className: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function CustomDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#ebe93e",
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const AddUserModal = ({
  open,
  addUserForm,
  disableSaveButton,
  handleAddUserFormChange,
  closeAddUserModal,
  handlePostAddUser,
}: {
  open: boolean;
  addUserForm: IAddUser | null;
  disableSaveButton: boolean;
  handleAddUserFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  closeAddUserModal: () => void;
  handlePostAddUser: () => void;
}) => {
  // States/Hooks - START --------------------------------------------------------------
  const inputFields: {
    name: string;
    label: string;
  }[] = [
    {
      name: "firstname",
      label: "First Name",
    },
    {
      name: "lastname",
      label: "Last Name",
    },
    {
      name: "email",
      label: "Email Address",
    },
  ];
  // States/Hooks - END ----------------------------------------------------------------

  return (
    inputFields && (
      <div className="add-user-modal">
        <CustomDialog
          onClose={() => {
            closeAddUserModal();
          }}
          open={open}
          className="add-user-modal-dialog"
          maxWidth="xl"
          fullWidth
          PaperProps={{
            elevation: 0,
            sx: {
              boxShadow: "0px 0px 4px #777",
            },
          }}
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          }}
        >
          <CustomDialogTitle
            className="add-user-modal-dialog-title"
            onClose={closeAddUserModal}
          >
            Add New User
          </CustomDialogTitle>
          <DialogContent dividers className="add-user-modal-dialog-content">
            <div className="pulse-row pulse-gap-1 pulse-p-1">
              {inputFields.map((field: any) => (
                <DefaultTextInput
                  key={field.name}
                  name={field.name}
                  label={field.label}
                  value={addUserForm && (addUserForm as any)?.[field.name]}
                  onChange={handleAddUserFormChange}
                  containerClassNames="pulse-default-text-input pulse-br-sm pulse-mb-2 pulse-col-xs-6 pulse-col-sm-6 pulse-col-md-6 pulse-col-lg-6 pulse-col-xl-6"
                  labelClassNames={`pulse-color--background-50
                pulse-typography-body-2 pulse-mb-1`}
                  inputClassNames="pulse-bg-color--background-800 pulse-typography-body-2"
                  type="text"
                />
              ))}
            </div>
          </DialogContent>
          <DialogActions className="add-user-modal-dialog-actions">
            <Button
              onClick={handlePostAddUser}
              className="add-user-modal-dialog-actions-button"
              disabled={disableSaveButton}
            >
              Submit
            </Button>
          </DialogActions>
        </CustomDialog>
      </div>
    )
  );
};
export default AddUserModal;
